import CompanyBillingDetails from './CompanyBillingDetails';

export * from './CompanyBillingDetails';

export default CompanyBillingDetails;
